export default {
  close: 'Закрыть',
  dataIterator: {
    pageText: '{0}-{1}-й результат / {2} результата',
    noResultsText: 'Результаты поиска не найдены.',
    loadingText: 'Загрузка наименования..',
  },
  dataTable: {
    itemsPerPageText: 'Количество строк на 1 странице:',
    ariaLabel: {
      sortDescending: ': Сортировка по убыванию. Активировать отмену сортировки.',
      sortAscending: ': Сортировка по возрастанию. Активировать сортировку по убыванию.',
      sortNone: ': Сортировка отсутствует. Активировать сортировку по возрастанию.',
    },
    sortBy: 'Сортировать по',
  },
  dataFooter: {
    itemsPerPageText: 'Количество результатов на 1 страницу：',
    itemsPerPageAll: 'Все',
    nextPage: 'Следующая страница',
    prevPage: 'Предыдущая страница',
    firstPage: 'Первая страница',
    lastPage: 'Последняя страница',
  },
  datePicker: {
    itemsSelected: 'Выбор даты {0}',
  },
  noDataText: 'Данные отсутствуют.',
  carousel: {
    prev: 'Предыдущее визуальное изображение',
    next: 'Следующее визуальное изображение',
  },
  calendar: {
    moreEvents: 'Дополнительно {0}',
  },
  fileInput: {
    counter: '{0} файлов',
    counterSize: '{0} файлов (всего: {1})',
  },
  observation: {
    accumulatedTemperature: 'Эффективная встроенная температура',
    accumulatedTemperatureList: 'Эффективный интегрированный список температур',
    startDateCalculation: 'Дата начала расчетов',
    endDateCalculation: 'Дата окончания накопления',
    lowerLimitTemperature: 'Температура нижнего предела',
    registerAndEditAccumulatedTemperaturePoints:
      'Регистрация/редактирование точки для расчета кумулятивной температуры',
    period: 'Период',
    accumulatedLowerLimitTemperature: 'Накопленная температура нижнего предела',
    deleteAccumulatedTemperatureLocation:
      'Вы уверены, что хотите удалить точки наблюдения интегральной температуры из 「{fieldName}」?',
    soilMoisture: 'Влажность почвы',
    soilTemperature: 'температура почвы',
    precipitation: 'осадки',
    soilMoistureList: 'Список влажности почвы',
    maxRegisterCount: '（До {count} предметов）',
    soilConditionVeryWet: 'Переувлажнение',
    soilConditionWet: 'Влажный',
    soilConditionDry: 'Сухость',
    soilConditionVeryDry: 'Пересушивание',
    drainage: 'Гранулометрический состав',
    registerAndEditSoilMoisturePoints: 'Регистрация/редактирование точек расчета влажности почвы',
    soilMoistureConditionGood: 'Хорошо',
    soilMoistureConditionSlightlyBad: 'Глинистый суглинок',
    soilMoistureConditionBad: 'Клей',
    soilMoistureConditionSandyLoam: 'Хорошо',
    soilMoistureConditionClayLoam: 'Глинистый суглинок',
    soilMoistureConditionClay: 'Клей',
    deleteSoilMoistureLocation:
      'Вы уверены, что хотите удалить точки наблюдения за влажностью почвы в 「{fieldName}」?',
    deletedField: '< Поле было удалено >',
    validateForStartDateBeforeYesterday: 'Дата начала должна быть как минимум за один день до',
    validateForStartEndDateOrder: 'Дата окончания должна быть позже даты начала',
    validateForStartEndDuration: 'Даты начала и окончания должны находиться в пределах {day} дней друг от друга',
    validateForStartNowDuration: 'Дата начала должна быть в пределах {day} дней от настоящего времени',
  },
  caster: {
    rtkInfo: 'Информация о коррекции RTK',
    rtkLog: 'Журнал связи',
    myBaseStationStatus: 'Состояние моей базовой станции',
    howToSetupRtkBase: 'При отправке корректирующей информации с продукта другой компании на "Мою базовую станцию"',
    howToSetupRtkRover:
      'При получении корректирующей информации от "Моей базовой станции" с помощью продукта другой компании',
    host: 'Хост',
    port: 'Порт',
    mountpoint: 'Маунт-Пойнт',
    derivedPassthroughLabel: ' (без преобразования)',
    derivedPassthroughCaption: 'Передаёт поправки базовой станции без изменений. Обычный вариант',
    derivedMsm4Label: ' (совместимость)',
    derivedMsm4Caption: 'Преобразование в MSM4: для приёмников, нестабильных с новейшим форматом (напр. MSM7)',
    derivedLegacyLabel: ' (для старых приёмников)',
    derivedLegacyCaption: 'Преобразование в устаревший формат 1004/1012: только GPS+GLONASS',
    derivedNote:
      'Если поправки не принимаются или нет FIX, попробуйте _MSM4 / _LEGACY. При подключении базовой станции не от AgriBus этот вывод может быть недоступен.',
    baseStation: 'Базовая станция',
    rover: 'Ровер',
    userId: 'ID пользователя',
    ntripUserId: 'Ntrip ID пользователя',
    ntripPassword: 'Ntrip пароль',
    showCaption: 'Показать',
    statusTab: 'Статус',
    qualityTab: 'Качество',
    mapTab: 'Карта',
    logTab: 'Журнал подключений',
    settingsTab: 'Настройки',
    baseShort: 'Базовая станция',
    casterServer: 'Сервер caster',
    roverShort: 'Ровер',
    receiving: 'Приём',
    stale: 'Приём остановился',
    noConnection: 'Нет подключения',
    lastReceivedAt: 'Последний приём',
    disconnectedAt: 'Отключено',
    summaryTitle: 'Приём базовой станции',
    lastSnapshotNote: 'Последние значения до отключения',
    noStatsData: 'Нет данных от базовой станции',
    bytesRate: 'Скорость данных',
    messagesPerSecond: 'Сообщения',
    epochInterval: 'Интервал эпохи',
    uptime: 'Время подключения',
    decodeErrors: 'Ошибки декодирования',
    basePosition: 'Позиция базы',
    antenna: 'Антенна',
    satellites: 'Спутники',
    signals: 'Сигналы',
    meanCnr: 'Среднее C/N0',
    msgType: 'Сообщение',
    msgCount: 'Количество',
    msgInterval: 'Интервал',
    msgLastSeen: 'Последний приём',
    cnrChart: 'Среднее C/N0 (дБ-Гц)',
    satsChart: 'Спутники',
    rateChart: 'Скорость данных (байт/с)',
    epochChart: 'Интервал эпохи (мс)',
    noHistoryData: 'Данных истории пока нет',
    noTrackData: 'Нет записей GGA ровера',
    baseline: 'Базовая линия',
    fixQuality: 'Качество fix',
    ggaPoints: 'Записанные точки',
    logBaseTitle: 'Подключения базовой станции',
    logRoverTitle: 'Подключения роверов',
    startAt: 'Начало',
    endAt: 'Конец',
    inSession: 'Подключено',
    userAgentLabel: 'Клиент',
    logNote: 'Показывает записи за последние 24 часа',
  },
  print: {
    field: {
      fillSetting: 'Заполните поле',
      backgroundWhiteColorSetting: 'Белый фон',
      backgroundNoColorSetting: 'Нет фона',
      printText: 'Печать',
      showFieldName: 'Показать имя поля',
    },
  },
  sortOptions: {
    title: 'Сортировать по',
    field: {
      name: 'Название поля',
      createdAt: 'Дата регистрации',
      lastModifiedDateTime: 'Измененная дата',
    },
  },
  fieldElevation: {
    title: 'высота',
    cantBuildBecauseNoTask: 'История работы не существует, поэтому невозможно создать карту высот.',
    nowBuilding: 'Подготовка... (В зависимости от площади поля, на создание может потребоваться некоторое время).',
    updatedAt: 'Дата создания',
    meshSize: 'Размер ячейки',
    taskFetchLimit: 'объём данных',
    taskDateRange: 'Область применения',
    taskPointCount: 'подсчет рабочих точек',
    editButton: 'Редактировать',
    createButton: 'Создать',
    needStandardPlan: 'Карта высот требует наличия Стандартного плана.',
    taskFetchLimitHint: 'Если нет разницы в высоте, увеличьте ее. Если имеется сильный шум, уменьшите его.',
    creationFailedMessage: 'Не удалось создать карту высот.',
    gnssStatus: 'Статус ГНСС',
    elevationRange: 'Диапазон высот',
    optionSetting: 'Настройка опций',
    minValue: 'Минимальное значение',
    maxValue: 'Максимальное значение',
    minIgnoreCaption: 'Возвышения ниже этого значения игнорируются',
    maxIgnoreCaption: 'Высота, превышающая это значение, будет игнорироваться',
    minValueNeedError: 'Пожалуйста, установите минимальное значение',
    maxValueNeedError: 'Пожалуйста, установите максимальное значение',
    minValueRangeError: 'Минимальное значение должно быть меньше максимального',
    maxValueRangeError: 'Максимальное значение должно быть больше минимального',
    invalidOptionSettingError: 'Указана недопустимая настройка опции',
    dateRangeInput: 'Диапазон дат',
    oldestTaskDateInput: 'Начальная дата',
    newestTaskDateInput: 'Конечная дата',
  },

  navi: {
    GeneralMainSettingMenuGnssSource: 'источник GNSS',
    GeneralMainSettingGnssSourceInternal: 'Внутренний',
    GeneralMainSettingGnssSourceGPlus: 'AgriBus-G+',
    GeneralMainSettingGnssSourceG2: 'AgriBus-G2',
    GeneralMainSettingGnssSourceGMini: 'AgriBus-GMini',
    GeneralMainSettingGnssSourceGMiniR: 'AgriBus-GMiniR',
    GeneralMainSettingGnssSourceUsb: 'USB',
    GeneralMainSettingGnssSourceBluetooth: 'Bluetooth',
    GeneralMainSettingGnssSourceTcpPort: 'порт TCP',
    GeneralMainSettingGnssSourceNtripClient: 'Ntrip клиент (Trimble, Topcon)',
    GeneralMainSettingGnssSourceVirtual: 'Virtual',
  },

  ValidationTextRequired: 'Требуется ввод',
  ResetPasswordTitle: 'Сброс и повторная установка пароля',
  ResetPasswordButton: 'Сброс пароля',
  ResetPasswordDescription:
    'На зарегистрированный адрес электронной почты будет отправлено сообщение со ссылкой для сброса и повторной установки пароля. Выполните сброс и повторную установку пароля согласно инструкциям, указанным в письме',
  ValidationBadEmail: 'Введите корректный адрес электронной почты',
  ChangePasswordButton: 'Сменить пароль',
  CreatePasswordButton: 'создать пароль',
  UnitTitle: 'Единицы изменения',
  UnitMetric: 'Метрическая система мер',
  UnitImperial: 'Английская система мер',
  UnitJpUnitsOfArea: 'Японские единицы площади',
  UnitThUnitsOfArea: 'Тайские единицы площади',
  NickNameHint: 'Имя',
  SendMeNews: 'Отправлять последние данные на адрес электронной почты',
  FreePlanDisplayName: 'Бесплатный план',
  StandardPlanDisplayName: 'Стандартном плане',
  ChangePasswordTitle: 'Сменить пароль',
  CreatePasswordTitle: 'Придумайте пароль',
  CurrentPasswordHint: 'Текущий пароль',
  NewPasswordHint: 'Новый пароль',
  SignInButton: 'Войти',
  ToResetPasswordButton: 'Забыл пароль',
  DocFormFieldDetailFieldNameHint: 'Название хозяйства',
  DocFormTaskRecordDetailFieldNameHint: 'Название записи о работах',
  DocFormTaskRecordDetailDescriptionHint: 'Примечания',
  DocFormTabNameTaskRecordList: 'История работ',
  DocFormTabNameRefLineList: 'Исходный курс системы управления',
  DocFormTabNameGridPointsList: 'Сетка',
  DocFormTabNameFieldList: 'Поле',
  DocFormFieldRegisteredDateFormatBase: 'Дата регистрации: {createDate}',
  DocFormMenuItemSignOut: 'Выйти',
  DocFormFieldDetailDescriptionHint: 'Примечания',
  StandardPlanIsNeededDialogMessage:
    'Данная функция доступна при покупке Стандартном плане на фиксированный срок (доступно 30-дневное бесплатное пробное использование)',
  SelectPlanDialogTitle: 'Выбрать план',
  SelectPlanDialogRecommend: 'Рекомендуется',
  SelectPlanDialogYearPlan: 'Годовой план',
  SelectPlanDialogYearPlanGreatValue: '(Скидка на 2 месяца)',
  SelectPlanDialogYearMonth: 'Месячный план',
  StandardPlanPriceForMonthBatch: 'Годовой тариф',
  StandardPlanPricePerMonth: '/Месяц',
  StandardPlanPricePerYear: '/Год',
  StandardPlanPriceForYearNotice: '* Оплата за 12 месяцев',
  SelectPlanSubscribeYear: 'Начать пробное использование сроком на 30 дней',
  SelectPlanSubscribeMonth: 'Начать 30-дневный пробный период',
  selectPlanDataViewNote: '* Если вы не возобновите подписку в течение примерно одного месяца после отмены, данные, записанные до отмены, перестанут отображаться (применяется с 1 октября 2026 г.). Экспортируйте необходимые данные в период действия подписки.',
  DefaultRefLineTypeStraight: 'Прямая линия',
  DefaultRefLineTypeCurved: 'Кривая линия',

  customSelectAll: 'Выбрать все',
  customUnSelectAll: 'Отменить все',
  customRegistration: 'Регистрация',
  customUpdate: 'Обновить',
  customSearch: 'Поиск',
  customDelete: 'Удалить',
  customAllow: 'Принять',
  customDeny: 'Отменить',
  customDefault: 'По умолочанию',
  customSelected: 'Выбрано',
  customSelectThis: 'Выбрать',
  customArea: 'Площадь',
  customNotAvailable: 'Недоступно',
  customEdit: 'Редактировать',
  customCancel: 'Отмена',
  customNone: 'Отсутствует',
  customClose: 'Закрыть',
  customFieldDrawHint: 'Нажимайте на карту, чтобы добавить вершины поля, затем подтвердите галочкой (кнопка отмены / Backspace удаляет последнюю точку)',
  customBack: 'Назад',
  customRefresh: 'Обновить',
  customUpload: 'Загрузить',
  customPriceIncludingTax: 'Стоимость (с учетом налога)',
  customPay: 'Оплата',
  customCancelContract: 'Расторжение договора',
  customConfirmReally: 'Выполнить?',
  customRememberMe: 'Сохранить',
  customLogin: 'Войти',
  customNowLoggingIn: 'Выполняется вход',
  customEmail: 'Адрес электронной почты',
  customPassword: 'Пароль',
  customUser: 'Пользователь',
  customUserSettings: 'Настройки пользователя',
  customSentEMailMessage: 'Сообщение отправлено.',
  customNewPasswordReInput: 'Введите повторно новый пароль',
  customValidationPasswordMinLength: 'Минимальное количество знаков в пароле должно составлять {length}',
  customValidationPasswordMaxLength: 'Слишком длинный',
  customValidationPasswordNotMatch: 'Пароль не совпадает',
  customChangePasswordSuccess: 'Пароль изменен',
  customGoToLoginPageTitle: 'Назад в меню паролей',
  customYouDontHaveAccount: 'При отсутствии аккаунта',
  customRegisterAgriBusWeb: 'Зарегистрироваться в AgriBus-Web',
  customChange: 'Изменить',
  customLanguage: 'Язык',
  customSaveAction: 'Сохранить',
  customSaveSuccess: 'Сохранено',
  customAddAction: 'Добавить',
  customPlan: 'План',
  customPlanExpirationDate: 'Дата окончания срока действия: {expirationDate}',
  customPlanDescription: 'Для изменения плана необходимо использовать приложение Android (AgriBus-NAVI).',
  customPlanOnly: 'Функция доступна только для Стандартном плане',
  customDetail: 'Подробнее',
  customDatePickerNullAlert: 'Сначала выберите дату',
  customTaskNotFound: 'История работ не найдена.',
  customTaskNotFoundAtDate: 'История работ не найдена. Дата выполнения работ: {date}',
  customErrorInitTasksFreePlan: 'В бесплатном плане история ограничена максимум 2 днями',
  customErrorInitTasksNoTasks: 'Если ничего не выводится, выполните "Синхронизацию данных" в AgriBus-NAVI!',
  customErrorInitFieldsNoFields:
    'Зарегистрированные хозяйства отсутствуют, поэтому "Синхронизация данных" в AgriBus-NAVI не выполнена.',
  customColored: 'Цвет',
  customHeight: 'Высота',
  customHeightMap: 'Карта высот',
  customSpeed: 'Скорость',
  customDate: 'Дата и время',
  customWorkWidth: 'Рабочая ширина',
  customWorkedArea: 'Рабочая площадь',
  customOverlappedArea: 'Перекрывающаяся область',
  customTaskRecordEfficiency: 'КПД',
  customDistance: 'Пройденное расстояние',
  customWorkedTime: 'Продолжительность работы',
  customAverageSpeed: 'Средняя скорость',
  customWorker: 'Работник',
  customDocFormTaskRecordDistanceOfFormatBase: '{distance} (Средняя {speed})',
  customDocFormTaskRecordWorkedAreaPercentageFormatBase: '{percentage}% из {fieldArea}',
  customDocFormTaskRecordWorkedAreaInfoFormatBase: '{areaPercentageText}, {efficiencyText}/h',
  customPageSuffix: 'Страница',
  customDisplayCount: 'Количество выведенных результатов',
  customTotalCount: 'Всего {count}',
  customListingModeSelf: 'Только свои данные',
  customListingModeAll: 'Включая отслеживание',
  customIconSettings: 'Настройка значков',
  customAccountHeader: 'Аккаунт',
  customConnectionHeader: 'Соединение',
  customConnectionTitle: 'Соединение',
  customFollowRequest: 'Запрос на отслеживание',
  customFollow: 'Отслеживать',
  customUnfollow: 'Прекратить отслеживание',
  customFollowing: 'Отслеживание',
  customFollower: 'Отслеживающие',
  customHaveNoFollowings: 'Отслеживание отсутствует.',
  customHaveNoFollowers: 'Отслеживающие отсутствуют',
  customInbox: 'Входящие',
  customOutbox: 'Исходящие',
  customInboxEmpty: 'Отсутствуют полученные запросы на отслеживание',
  customOutboxEmpty: 'Отсутствуют отправленные запросы на отслеживание',
  customSendFollowRequest: 'Отправить запрос на отслеживание',
  customSendFollowRequestMessage: 'Запрос на отслеживание отправлен',
  customFollowRequestSelfRequestError: 'Отравка запроса на отслеживанеи самому себе невозможна.',
  customAllowFollowRequest: 'Одобрен запрос на отслеживание от {fromNickname}',
  customUnfollowMessage: 'Отслеживание прекращено',
  customUpdatedIconMessage: 'Значок измененен',
  customIconNowSelected: 'Выбрано',
  customIcon: 'значок по умолчанию',
  customIconSettingsDescription: 'Мы рекомендуем вам установить свой собственный значок.',
  customIconChangeToIcon: 'Изменить по умолчанию',
  customGravatarIcon: 'Gravatar',
  customIconSettingsGravatarDescription:
    'Рекомендуется к выбору лицам, у которых настройка значков выполнена в Gravatar.',
  customIconChangeToGravatar: 'Изменить на Gravatar',
  customCustomIcon: 'Индивидуальный значок',
  customIconSettingsCustomDescription:
    'Доступна настройка предпочтительных фото. Подготовьте файл в формате JPEG или PNG.',
  customIconChangeToCustom: 'Изменить на индивидуальный значок',
  customIconReUpload: 'Повторить загрузку',
  customTemperature: 'Температура',
  customHumidity: 'Влажность',
  customWind: 'Скорость ветра',
  customPressure: 'Атмосферное давление',
  customSunrise: 'Восход',
  customSunset: 'Закат',
  customShowAllCropsDescription: 'Показать все',
  customShowCurrentCropsDescription: 'Показать только текущие данные',
  customProduct: 'Посадка',
  customProductsNotFound: 'Посадка не найдена',
  customColor: 'Цвет',
  customYear: 'Год',
  customCrop: 'Сельскохозяйственная культура',
  customCropVariety: 'Сорт',
  customDeleteCropConfirmationMessage:
    'Удалить {cropYear} {cropName} {cropVariety} ? (также будет удалена сопутствующая информация)',
  customOperationType: 'Работа',
  customFilter: 'Фильтр',
  customOutOfField: 'За пределами поля',
  customBillingPlan: 'Тарифный план',
  customBillingAndPayment: 'Стоимость и оплата',
  customBillingMethod: 'Способ оплаты',
  customBillingExistingCard: 'Зарегистрированные карты',
  customBillingAddNewCard: 'Добавить новую карту',
  customBillingMethodConfirm: 'Подтвердите способ оплаты',
  customBillingHistory: 'История оплаты',
  customCreditCard: 'Кредитная карта',
  customCreditCardLast4: 'Последние 4 цифры',
  customCreditCardNameOnCard: 'Фамилия и имя, указанные на карте',
  customCreditCardInfo: 'Данные карты',
  customCreditCardAddCard: 'Добавить карту',
  customCreditCardAddCardCaution1:
    'В этот раз списание денежных средств с карты не осуществляется. Карта будет зарегистрирована для выполнения будущих платежей.',
  customCreditCardAddCardCaution2:
    'Если вы хотите оплатить счет, пожалуйста, свяжитесь с нами по адресу contact@agri-info-design.com до регистрации вашей карты.',
  customCreditCardNoCard: 'Зарегистрированные кредитные карты отсутствуют.',
  customCreditCardDeleteFailure: 'Не удалось удалить карту',
  customMyProducts: 'Мои продукты',
  customMyProductsList: 'Перечень продуктов',
  customMyProductProduct: 'Изделие',
  customMyProductProductNumber: 'Номер изделия',
  customMyProductDataPlan: 'Тарифный план',
  customMyProductDataPlanSubscribe: 'Договор тарифного плана',
  customMyProductDataPlanSubscribeSuccessMessage: 'Скоро будет доступна 3G-связь для {productNumber}.',
  customMyProductDataPlanExpiredMessage: 'Срок действия истек {expiredDate}',
  customMyProductDataPlanCancelConfirmationMessage:
    'В случае аннулирования плана 3G-связь будет недоступна. Кроме того, возврат суммы оплаты за остаточный срок действия договора не осуществляется. В то же время, после расторжения договор может быть заключен повторно. Расторгнуть договор?',
  customRealTime: 'Реальное время',
  customRealTimeSettings: 'Настройка реального времени',
  customModel: 'Модель',
  customSystemVersion: 'Версия системы',
  customWebMarkerIcon: 'Значок',
  customWebMarkerSetting: 'Настройка маркеров',
  customWebMarkerName: 'Название маркера',
  customWebMarkerColor: 'Цвет маркера',
  customRealtimeChooseYourDevice: 'Выберите устройство',
  customRealtimeDeviceNotActive: 'Устройство не активно',
  customElevation: 'Отметка',
  customGnss: 'GNSS',
  customSatellites: 'Спутник',
  customFirmwareVersion: 'Версия встроенного программного обеспечения',
  customHasFirmwareUpdate: 'Доступны последние обновления',
  customFirmwareDownloadMessage: 'Выпущена новая версия {newestFirmwareVersion}.',
  customDownload: 'Скачать',
  customFieldRegistration: 'Регистрация нового хозяйства',
  customFieldCreateWithMapTitle: 'Создать хозяйство на карте',
  customFieldCreateWithMapTitleDescription: 'Создать новое хозяйство на карте',
  customFieldCreateWithMapButton: 'Создать',
  customFieldCreateWithMapFieldName: 'Название поля',
  customFieldCreateWithMapLoadingMap: 'Загрузка карты',
  customFieldCreateWithMapCreate: 'Создать',
  customFieldCreateWithMapCreateFinishedMessage: 'Создано хозяйство {fieldName}',
  customFieldCreateWithMapCreateErrorMessage: 'Не удалось создать хозяйство {fieldName}',
  customFieldCreateWithMapNoFieldMessage: 'Составьте хозяйство на карте',
  customFieldCreateWithMapNoFieldNameMessage: 'Введите название хозяйства',
  customFieldCreateWithMapTooManyFieldsMessage: 'Количество хозяйств, доступных для создания: 1',
  customFieldUploadTitle: 'Загрузка KML/Shapefile',
  customFieldUploadMessage: 'Загрузите доступный файл KML/KMZ или Shapefile',
  customFileUploadShapefileDescription:
    'Для Shapefile необходим архивный (сжатый) файл ZIP, который включает в себя нижеперечисленные файлы.',
  customFieldUploadFileInput: 'Выберите файл',
  customFileUploadShpDescription: '.shp（Информация о рельефе）',
  customFileUploadShxDescription: '.shx（Индексная информация）',
  customFileUploadDbfDescription: '.dbf（Информация атрибута）',
  customFileUploadPrjDescription: '.prj（Информация о системе географических координта）',
  customFileUploadPrjCaution: '.prj необходим для правильного считывания координат.',
  customFileUploadTextEncodingDescription: 'В случае искажения названия атрибута выполните замену.',
  customFileUploadAttributeNameForFieldName: 'Названите атрибута, используемое в качестве названия хозяйства',
  customFileUploadFieldImportStart: 'Начать импорт хозяйств в количестве {count} ед.',
  customFileUploadImportCheckTitle: 'Импортировать',
  customFileUploadFieldImportStartedMessage:
    'Начался импорт хозяйства. При большом количестве наименований процесс обработки может занять несколько минут.',
  customFieldUploadErrorMessage: 'Невозможно выполнить считывание загруженных файлов',
  customFieldThisFieldName: 'Хозяйство「{fieldName}」',
  customFieldUnknownFieldName: 'Это хозяйство',
  customFieldNoName: 'Без поля',
  customFieldDeleteAlertWithTask:
    'Имеется {count} историй работ в хозяйстве {fieldName}. Удаление приведет к потере данных по хозяйству, к которым относятся соответствующая истории работ. Продолжить удаление?',
  customFieldDeleteAlertWithoutTask: 'Удалить {fieldName}?',
  customTextEncoding: 'Кодирование',
  customFieldImportFinishedMessage: 'Импорт хозяйств в количестве {count} ед. выполнен успешно',
  customFieldImportErrorMessage: 'Не удалось импортировать хозяйства',
  customFieldCount: 'Количество хозяйтсв: {count} ед.',
  customExport: 'экспорт',
  customTaskExport: 'Экспорт истории работ',
  customTaskWhatIsAgriBusFormat:
    'Формат AgriBus представляет собой текст с разделителями табуляции, что обеспечивает его простоту в обработке.',
  customTaskNowDeveloping: 'В процессе разработки',
  customTaskNowDevelopingDescription: 'Скоро будет доступен вывод в других форматах.',
  customTaskStartExporting: 'Начало экспорта',
  customTaskNowExporting: 'Выполняется экспорт...',
  customTaskDownloadReady: 'Подготовка к скачиванию завершена',
  customFieldHeader: 'Поле',
  customDarkMode: 'Темный режим',
  customNewRegistration: 'Новая регистрация',
  customCreateNew: 'Создать',
  customImport: 'Импорт',
  customListDisplay: 'Вид списком',
  customCardDisplay: 'Вид карточками',
  customCalendarDisplay: 'Вывести календарь',
  customFieldsList: 'Список полей',
  customPleaseSignUpFromAndroidApplication:
    'Подпишитесь через приложение Android <span class="aid-logotype">AgriBus-NAVI</span>',
  customWhatIsAgribusNAVI: 'Что такое <span class="aid-logotype">AgriBus-NAVI</span>?',
  customAgriBusNAVIDescription:
    '<span class="aid-logotype">AgriBus-NAVI</span> представляет собой приложение GPS-(GNSS-) управления для операционной системы Android, которое устанавливается на тракторах, комбайнах, самоходных распылителях и других видах сельскохозяйственной техники и устройств и помогает осуществлять работы при прямолинейном движении на территории хозяйства.Если загрузить данное приложение на смартфон или планшет и в дальнейшем осуществлять управление техникой, одновременно сверяясь с данными, которое выводит упомянутое приложение, то появится возможность осуществлять сельскохозяйственные работы при прямолинейном движении и с равными интервалами на большой площади.',
  customProductDetails: 'Ознакомиться с подробной информацией об изделии',
  aid: {
    calendar: {
      month: 'Месяц',
      week: 'Неделя',
      day: 'День',
      fourDays: '4 дня',
    },
  },
  customTaskFilterAllSelect: 'Все работы',
  customTaskFilterGetError: 'Не удалось получить информацию о фильтре',
  customTaskFilterPostError: 'Не удалось зарегистрировать информацию о фильтре',
  customTaskFilterPutError: 'Не удалось обновить информацию о фильтре',
  customTaskFilterDeleteError: 'Не удалось удалить информацию о фильтре',
  customTaskFilterPostSucceed: '{filtername} зарегистрирован',
  customTaskFilterPutSucceed: '{filtername} обновлен',
  customTaskFilterSetDefault: 'Установите "{filtername}" в качестве фильтра по умолчанию',
  customTaskFilterDeleteSucceed: 'Информация о фильтре удалена',
  customTaskFilterSelectCheckError: 'Соответствующий фильтр отсутствует. Выберите фильтр',
  customTaskFilterDuplicateCheckError: 'Название фильтра повторяется',
  customTaskFilterNotEnteredCheckError: 'Не введено название фильтра',
  customTaskFilterStringNarrowing: 'Сузить строку символов',
  customTaskFilterMakeDefault: 'Всегда используйте этот фильтр',
  customTaskFilterName: 'Название фильтра',
  customTaskFilterDeleteMsg: 'Удалить {filtername}?',
  customTaskFilterDialogTitle1: 'Фильтровать историю работы',
  customTaskFilterDialogTitle2: 'Применить сохраненные настройки фильтра',
  customTaskFilterCreateNew: 'Создать новую настройку фильтра',
  customTaskFilterEdit: 'Редактирование фильтра',
  customTaskFilterSetting: 'Настройка фильтра',
  customTaskFilterCurrent: 'Фильтр тока',
  customTaskFilterNoTasksError: 'Из-за настройки фильтра "{filtername}" количество отображаемых элементов равно 0.',
  customTaskFilterAreaZeroHidden: 'Исключая работу с нулевой рабочей зоной',
  customTaskFilterDistanceUnderTenHidden: 'Исключая работу с пробегом менее 10 м (10.936yd).',
  customTaskFilterNoField: 'Nenhum campo',
  customTaskFilterNoCrop: 'Sem cultura',
  customTaskFilterOutOfFieldHidden: 'Exclui o histórico de tarefas fora do campo',
  customSimpleSignUpNow: 'Регистрация...',
  customSimpleSignUpSuccess: 'Отправлено сообщение для завершения регистрации. Проверьте свой почтовый ящик.',
  customEnterpriseInviteSuccess: 'Я отправил тебе приглашение по электронной почте',
  customSimpleSignUpFailed: 'Регистрация не выполнена',
  customSimpleSignUpUserAlreadyExists: 'Проблема с адресом электронной почты.',
  customSimpleSignUpServerError: 'Ошибка в процессе регистрации',
  customDateFilterStartDate: 'Дата начала действия фильтра',
  customDateFilterEndDate: 'Дата окончания действия фильтра',
  customDateFilterCalendarType: 'Формат календаря',
  customDateFilterCalendarTypeDate: 'День',
  customDateFilterCalendarTypeMonth: 'Месяц',
  customDateFilterSetBotton: 'Настройка',
  customDateFilterRangeError: 'Дата окончания действия предшествует дате начала действие. Выберите даты ещё раз.',
  customCurrency: 'Валюта',
  customBillingCurrencyJPY: 'Японские иены',
  customBillingCurrencyUSD: 'Доллары США',
  customBillingPurchase: '30 дней бесплатного пробного использования',
  customBillingPurchaseWithoutTrial: 'Улучшить',
  customBillingPlanInfo: 'Информация о плане',
  customBillingNowPlan: 'Действующий план',
  customBillingTrial: 'Пробное использование',
  customBillingCancellation: 'Аннулирование',
  customBillingContractPeriod: 'Срок действия договора',
  customBillingAmount: 'Сумма',
  customBillingAlertMustRegisterCard: 'Для покупки необходимо заранее зарегистрировать кредитную карту.',
  customBillingMessageUnsubscribe: 'Оплаченные планы отменены.',
  customBillingMessageSubscribe: 'Благодарим за покупку',
  customBillingMessageUnSubscribeGoogle:
    'В настоящее время оплата осуществляется через Google Play. Выполните расторжение договора через Google Play.',
  customBillingReceipt: 'Счета-фактуры / квитанции',
  customBillingMessageCancelStandardPlan:
    'Если вы отмените свой платный тарифный план, вы все равно сможете пользоваться услугой в течение периода, за который вы заплатили. Если я отменю здесь, я автоматически перейду на бесплатный тарифный план после {date}, это все еще правильно?',
  customBillingMessageCancelTrial:
    'В настоящее время вы находитесь в пробном периоде, но если вы отмените его здесь, вы немедленно вернетесь к бесплатному плану. Обратите внимание, что после отмены вы можете подписаться на новый платный тарифный план, и в этом случае пробный период больше не будет действовать.',
  customBillingStandardDescription:
    'Один месяц бесплатно при оплаченном годовом плане; воспользуйтесь всеми возможностями, включая бессрочное хранение данных AgriBus-Web и отображение положения транспортного средства в режиме реального времени, а также функцию наведения на кривую и информационный лоток AgriBus-NAVI! ',
  customBillingMenu: 'Управление действующим планом',
  customBillingMore: 'Подробнее',
  customAdRow1_1: 'Стандартном плане',
  customAdRow1_2: 'Информационная революция в сельском хозяйстве.',
  customAdRow2_1: '3 преимущества',
  customAdRow2_2: 'Неограниченное хранение и экспорт данных',
  customAdRow2_3: 'Вывод местоположения техники в режиме реального времени',
  customAdRow2_4: 'Применение AgriBus-Caster',
  customAdRow3_1: '3 преимущества',
  customAdRow3_2: 'Добавление разницы высот, скорости движения и других параметров в рабочую траекторию',
  customAdRow3_3: 'Сохранение и применение исходного курса системы управления',
  customAdRow3_4: 'Применение системы управления для курса движения по прямой',
  customOAuthMessage: 'Во время аутентификации...',
  customGoogleOAuthBtn: 'Войти через Google',
  customGoogleOAuthSignUpBtn: 'Зарегистрируйтесь с помощью Google',
  customOAuthError: 'Ошибка в процессе аутентификации OAuth',
  customOAuthGetUserInfoError: 'Произошла ошибка при получении информации OAuth',
  customOAuthServerError: 'Произошла ошибка в процессе регистрации учетных данных OAuth',
  customOAuthFailed: 'Ошибка аутентификации OAuth',
  customToBillingPage: 'К стандартному плану покупки экрана',
  customTasksListFreePlanMsg:
    'В бесплатном плане история работ отображается только за 2 дня. Подписавшись на Стандартном плане, вы можете иметь неограниченный срок хранения.',
  customEnterprise: 'Предприятие',
  customEnterpriseSetting: 'Настройки предприятия',
  customEnterpriseManagement: 'Управление предприятием',
  customWhatIsEnterprise: 'Что такое "Агрибус-Веб Энтерпрайз"?',
  customEnterpriseRegistration: 'Подпишитесь на план предприятия',
  customPleaseContinueToRegisterForEnterprise:
    'Пожалуйста, продолжайте процесс регистрации AgriBus-Web Enterprise из полученного электронного письма.',
  customPleaseInputOrganizationName: 'Пожалуйста, введите название вашей организации.',
  customEnterpriseName: 'Имя предприятия',
  customMaxOfMemberThisMonth: 'Максимальное количество участников в этом месяце',
  customExpectedPaymentAmountForThisMonth: 'Сметная сумма платежа за этот месяц',
  customDateOfPayment: 'Дата оплаты',
  customPaymentHistory: 'История платежей',
  customEditEnterpriseName: 'Редактировать Имя предприятия',
  customOrganization: 'Организация',
  customOrganizationName: 'Название организации',
  customAdministrator: 'Администратор',
  customOrganizationList: 'Диаграмма организационной структуры',
  customNewOrganization: 'Создание новой организации',
  customCreateOrganization: 'Создать организацию',
  customEditOrganizationName: 'Отредактировать название организации',
  customTeam: 'Команда',
  customTeamList: 'Список команд',
  customMyTeam: 'Моя команда',
  customMyTeamList: 'Список моей команды',
  customNewTeam: 'Создание новой команды',
  customTeamName: 'Имя команды',
  customCreateTeam: 'Создать команду',
  customRemoveFromTeam: 'Удалён из команды',
  customEditTeam: 'Редактирование в команде',
  customMember: 'Член',
  customMemberName: 'имя участника',
  customAddNewMember: 'Добавить члена',
  customNumberOfMember: 'Количество участников',
  customInviteMembers: 'Приглашаем участников',
  customSendInvitationEmail: 'Отправить приглашение по электронной почте',
  customPleaseEnterTheNameOfTheMember: 'Пожалуйста, укажите имена приглашаемых членов.',
  customMemberList: 'Список членов',
  customEditMember: 'Член редакции',
  customInviting: 'Во время приглашения',
  customRestrictFollow: 'Следующее ограничение',
  customPermission: 'Права доступа',
  customPermissionName: 'Имя авторизации доступа',
  customRoleName: 'Имя роли',
  customAction: 'Действие',
  customIndividualCreation: 'Индивидуальное творение',
  customConfirmTeamDeletion: 'Могу я убрать эту команду?',
  customConfirmMemberRemovalFromTeam: 'Могу я удалить этого члена из команды?',
  customSelectTeamsForMemberToJoinDialogTitle: 'Выберите команды, к которым присоединится член',
  customSelectTeamsForMemberToJoinDialogOK: 'Добавить в выбранную команду',
  customSelectMembersAddToTeamDialogTitle: 'Пожалуйста, выберите членов, чтобы присоединиться к команде',
  customSelectMembersAddToTeamDialogOK: 'Добавить выбранных членов',
  customFollowMembersDialogTitle: 'Пожалуйста, выберите члена',
  customFollowMembersDialogOK: 'Следуйте за выбранным членом',
  customTeamFollowSelectDialogTitle: 'Пожалуйста, выберите команду',
  customTeamFollowSelectDialogOK: 'Следуйте за выбранными командами',
  customPleaseConfirm: 'Пожалуйста, проверьте.',
  customEnterpriseSignUpForPleaseConfirmDescription1:
    'Пользователь с указанным адресом электронной почты входит в Стандартном или корпоративный плане.',
  customEnterpriseSignUpForPleaseConfirmDescription2:
    'Если у вас есть Стандартном плане, пожалуйста, подпишитесь на корпоративный план после того, как вы его отмените.',
  customEnterpriseSignUpForFreePlanDescription:
    'Пользователи с указанным адресом электронной почты находятся на бесплатном тарифном плане. Могу ли я перейти на план "Энтерпрайз"?',
  customEnterpriseSignUpForStandardPlanDescription:
    'Пользователь с указанным адресом электронной почты отменил свой Стандартный тарифный план, но он все еще активен. Хочешь перейти на план "Энтерпрайз"? (Пожалуйста, обратите внимание, что если пользователь все еще должен за Стандартный тарифный план, он будет платить как за Стандартный тарифный план, так и за Энтерпрайз.)',
  customAddFollowMembers: 'Добавить следующего члена',
  customAddFollowTeams: 'Добавить следующую команду',
  customBillingMaxMember: 'Максимальное число участников',
  customCreditCardRegistration: 'Регистрация кредитной карты',
  customNext: 'Следующий',
  customGoBackOneStep: 'Назад к предыдущему',
  customRestriction: 'Ограничение',
  customMemberSuspension: 'Ты уверен, что хочешь перестать использовать этого члена?',
  customResumeMemberUsage: 'Вы уверены, что хотите возобновить использование этого члена?',
  customRestart: 'Перезапустить',
  customSuspended: 'Приостановленный',
  customAddToExistingTeam: 'Добавить в существующую команду',
  customFollowFunction: 'Следующая функция',
  customAllowToAddAndRemoveFollow: 'Позвольте добавить и удалить следующее',
  customAllowToAddAndRemoveFollowDescription:
    'Этот член не имеет права самостоятельно добавлять или удалять последователей.',
  customNotAllowToAddAndRemoveFollow: 'Не позволяйте добавлять и удалять следующие',
  customNotAllowToAddAndRemoveFollowDescription: 'Этот член может свободно добавлять и удалять последователей.',
  customEnterprisePlanDisplayName: 'План предприятия',
  customPricePerMember: 'Цена за члена.',
  customPerMember: 'На каждого члена',
  customNotesOnPlanSelection:
    'Сумма выставленного счета - максимальное количество участников в расчетном месяце х стоимость единицы.',
  customDueDateForFirstRepayment: 'Дата первого платежа',
  customEnterprisePlanStart: 'Начать',
  customUnsubscribeFromEnterprise: 'Отписаться от плана предприятия',
  customReturnAgriBusWeb: 'Вернуться к Agri-Bus Web',
  customAboutCreditCardPayment: 'Об оплате кредитной картой',
  customClickHereUnsubscripbeFromEnterprise: 'Нажмите здесь, чтобы отписаться от плана "Энтерпрайз".',
  customEnterpriseWithdrawText1:
    'В связи с выходом из членства, счет за этот месяц будет последним в этом месяце и никаких дальнейших платежей производиться не будет.',
  customEnterpriseWithdrawText2:
    'Мы будем продолжать развивать каждый продукт серии AgriBus в будущем, поэтому, если у вас есть шанс, пожалуйста, взгляните еще раз.',
  customEnterpriseWithdrawText3:
    'Мы хотели бы поблагодарить Вас за использование каждого из продуктов серии AgriBus, даже если это было только на мгновение. Благодарим вас за интерес к нашей продукции.',
  customErrorEnterpriseWithdraw: 'Вы не отменили план "Энтерпрайза". Пожалуйста, попробуйте еще раз.',
  customGuidanceInterval: 'интервал управления',
  customWorkingWidth: 'ширина захвата',
  customRefLineLength: 'Длина направляющей линии',
  customRefLine: 'руководство линии',
  customExportRefLine: 'Экспорт базовой линии',
  customDirecton: 'распоряжение',
  customShowTaskDetailError:
    'История работы отсутствует, возможно, она была не синхронизирована с AgriBus-NAVI или удалена.',
  customFileUploadAttributeNameForRefLineName: 'Имя атрибута, которое будет использоваться в качестве базового имени',
  customFileUploadRefLineImportStart: 'Начните с {count} контрольных линий.',
  customFileUploadShapefileDescriptionForRefLines:
    'Для работы Shapefile требуется zip-архив (сжатый) файл только для следующих файлов',
  customFileUploadShpDescriptionForRefLines: 'Swaths.shp (Топографическая информация)',
  customFileUploadShxDescriptionForRefLines: 'Swaths.shx (информация об индексах)',
  customFileUploadDbfDescriptionForRefLines: 'Swaths.dbf (информация об атрибутах)',
  customRefLineImportFinishedMessage: 'Нам удалось захватить {count} опорных линий.',
  customRefLineImportErrorMessage: 'Мне не удалось запечатлеть исходную точку.',
  customRefLineAddTitle: 'Новая регистрация для руководства линии',
  customRefLineImportTitle: 'Загрузка Shapefile',
  customRefLineImportText: 'Загрузить свой Shapefile',
  customRefLineImportText2: 'Импортировать можно только контрольные линии, выводимые из Trimble CFX-750.',
  customRefLineCreateTitle: 'Создать базовую линию на карте',
  customRefLineCreateText: 'Создать базовую линию на карте',
  customRefLineUploadTitle: 'Загрузка базовой линии',
  customRefLineNameHint: 'название контрольной строки',
  customRefLineDeleteAlert: 'Вы уверены, что хотите удалить {refLineName}?',
  customRefLineDeleteUnknownName: 'Эта направляющая линия',
  customRefLineDeleteKnownName: 'Ссылочная линия "{refLineName}".',
  customRefLineDeleteError: 'Не удалось удалить контрольную линию.',
  customThunderstormWithLightRain: 'Гроза с легким дождем',
  customThunderstormWithRain: 'Гроза с дождём',
  customThunderstormWithHeavyRain: 'Гроза с проливным дождём',
  customThunderstormWithLightDrizzle: 'Гроза с моросящим дождем',
  customThunderstormWithDrizzle: 'Гроза с моросью',
  customThunderstormWithHeavyDrizzle: 'Гроза с сильным моросящим дождем',
  customThunderstormWithHail: 'Гроза с Радостью',
  customLightDrizzle: 'Световой дождь',
  customDrizzle: 'Drizzle',
  customHeavyDrizzle: 'сильный сток',
  customLightRain: 'Световой дождь',
  customModerateRain: 'Умеренный дождь',
  customHeavyRain: 'сильный дождь',
  customFreezingRain: 'Замораживающий дождь',
  customLightShowerRain: 'Легкий дождь в душе',
  customShowerRain: 'Дождь из душа',
  customHeavyShowerRain: 'Проливной дождь в душе',
  customLightSnow: 'Легкий снег',
  customSnow: 'Снег',
  customHeavySnow: 'Тяжелый снег',
  customMixSnowRain: 'Смешивать снег/деревню',
  customSleet: 'Слет',
  customHeavySleet: 'Тяжелая мокрая слякоть',
  customSnowShower: 'Снежный душ',
  customHeavySnowShower: 'Сильный снежный душ',
  customFlurries: 'Шквалы',
  customMist: 'Туман',
  customSmoke: 'Курить',
  customHaze: 'Haze',
  customSandDust: 'Песок/пыль',
  customFog: 'Туман',
  customFreezingFog: 'Морозный туман',
  customClearSky: 'Чистое небо',
  customFewClouds: 'Мало облаков',
  customScatteredClouds: 'Разрозненные облака',
  customBrokenClouds: 'Разбитые облака',
  customOvercastClouds: 'Облака облака',
  customUnknownPrecipitation: 'Выпадение неизвестных осадков',
  customWeatherInfoTitle: 'Информация о погоде',
  customWeatherDescriptionTitle: 'погода',
  customWindSpeedTitle: 'сила ветра',
  customTemperatureTitle: 'температура',
  customRelativeHumidityTitle: 'уровень влажности',
  customNumOfSatellites: 'количество спутников',
  customGnssStatus: 'статус GNSS',
  customLeftRightMisalignment: 'рассогласованность',
  customAzimuthShift: 'азимутальный сдвиг',
  customGradient: 'градиент',
  customTimeOfAcquisition: 'время приобретения',
  customWorkOverview: 'обзор работы',
  customImageStorage: 'хранение изображений',
  customMapGaugeDescriptionNone: 'Отображается заливка работы без цветовой кодировки',
  customMapGaugeDescriptionHeight: 'Разница в высоте работы отображается цветом',
  customMapGaugeDescriptionSpeed: 'Скорость работы отображается цветом',
  customMapGaugeDescriptionNumOfSatellites:
    'Количество спутников позиционирования на момент работы отображается разными цветами',
  customMapGaugeDescriptionGnssStatus: 'Статус GNSS на момент работы отображается цветом.',
  customMapGaugeDescriptionLeftRightMisalignment:
    'Отклонение влево-право от направления во время работы отображается цветом.',
  customMapGaugeDescriptionAzimuthShift: 'Цветная индикация несовпадения с указаниями во время работы',
  customMapGaugeDescriptionGradient: 'Наклон при работе отображается разными цветами (только G2, GMiniR, Gmini).',
  customPrecipitationTitle: 'Осадки',
  customWeathercomTornado: 'Торнадо',
  customWeathercomTropicalStorm: 'тропический шторм',
  customWeathercomHurricane: 'Ураган',
  customWeathercomStrongStorms: 'Сильные бури',
  customWeathercomThunderstorms: 'Грозы',
  customWeathercomRainSnow: 'Дождевой снег',
  customWeathercomRainSleet: 'Дождевой слон',
  customWeathercomWintryMix: 'Победная смесь',
  customWeathercomFreezingDrizzle: 'моросящий дождь',
  customWeathercomDrizzle: 'Drizzle',
  customWeathercomFreezingRain: 'Замораживающий дождь',
  customWeathercomShowers: 'Душ',
  customWeathercomRain: 'Дождь',
  customWeathercomFlurries: 'Шквалы',
  customWeathercomSnowShowers: 'Снежные души',
  customWeathercomBlowingDriftingSnow: 'Выдувной дрейфующий снег',
  customWeathercomSnow: 'Снег',
  customWeathercomHail: 'Hail',
  customWeathercomSleet: 'Слет',
  customWeathercomBlowingDustSandstorm: 'Пыльная буря',
  customWeathercomFoggy: 'Туманный',
  customWeathercomHaze: 'Haze',
  customWeathercomSmoke: 'Курить',
  customWeathercomBreezy: 'Бризи',
  customWeathercomWindy: 'Ветреный',
  customWeathercomFrigidIceCrystals: 'Холодные ледяные кристаллы',
  customWeathercomCloudy: 'Облачный',
  customWeathercomMostlyCloudy: 'В основном облачно',
  customWeathercomPartlyCloudy: 'Частично облачно',
  customWeathercomClear: 'Clear',
  customWeathercomSunny: 'Солнечный',
  customWeathercomFairMostlyClear: 'Яснее всего ясно.',
  customWeathercomFairMostlySunny: 'Честно говоря, самое солнечное',
  customWeathercomMixedRainandHail: 'Смешанный Дождь и Слава',
  customWeathercomHot: 'Горячий сайт',
  customWeathercomIsolatedThunderstorms: 'Изолированные грозы',
  customWeathercomScatteredThunderstorms: 'Разрозненные грозы',
  customWeathercomScatteredShowers: 'Разрозненные души',
  customWeathercomHeavyRain: 'сильный дождь',
  customWeathercomScatteredSnowShowers: 'Разбросанные снежные души',
  customWeathercomHeavySnow: 'Тяжелый снег',
  customWeathercomBlizzard: 'Метель',
  customWeathercomNotAvailable: 'Нет в наличии',
  customSharedMountPointSetting: 'Установка точки крепления',
  customSharedMountPointSettingTitle:
    'Задайте точку монтирования опорной станции RTK, которая будет совместно использоваться внутри организации.',
  customSharedMountPoint: 'общая точка крепления',
  customMountPoint: 'точка крепления',
  customStatus: 'статус',
  customNotSet: 'Не готово.',
  customSelectMountPoint: 'Выберите точку крепления',
  customUnsharedMountPoint: 'Необщая информация',
  customSelectMountPointTitle: 'Выберите точку крепления для совместного использования',
  customSharedMountPointRemarks1:
    'Точки крепления выдаются, когда AgriBus-GMiniR устанавливается в качестве базовой станции с помощью приложения AgriBus-GTools. Если Вы используете референцную станцию другого производителя, пожалуйста, обратитесь к нам по ссылке, приведенной ниже.',
  customSharedMountPointRemarks2: 'Нажмите здесь, чтобы подать заявку.',
  customOnline: 'онлайн',
  customOffline: 'офлайн',
  customNotIssued: 'невыпущенный',
  customSetItUp: 'Все готово.',
  customDeActivated: 'Деактивирован.',
  customType: 'классификация',
  customCropIsNotRegistered: 'Урожай не зарегистрирован.',
  customNameNotRegistered: 'Имя Незарегистрированный',

  customGoToPayerManager: 'Откройте страницу администрирования',
  customPaymentInfo: 'Информация по оплате',
  customProjectInfo: 'Информация о проекте',
  customAddProject: 'Добавить Проект',
  customAddProjectRemarks: 'Пожалуйста, укажите название проекта и адрес электронной почты администратора.',
  customProjectName: 'Название проекта',
  customProjectAdminMailAddress: 'Электронная почта администратора',
  customStop: 'остановиться на',
  customStopDialogText: 'Вы хотите удалить выбранный проект?',
  customDone: 'Готово.',
  customUpdateDay: 'дата обновления',
  customAdminName: 'Имя менеджера',
  customMaxQuantity: 'максимальное число людей',
  customaddProjectSuccess: 'Ваш проект добавлен.',
  customPlantingShowPast: 'Показать прошлые посадки',
  customPlantingHidePast: 'Скрыть прошлые посадки',
  customPlantingCropDisplayName: 'отображаемое имя культуры',
  customPlantingCropVarietyName: 'Название сорта',
  customPlantingSeason: 'Сезон выращивания',
  customPlantingSeasonStartDate: 'Дата начала (требуется)',
  customPlantingSeasonEndDate: 'Дата окончания',
  customPlantingAddCropOption: 'Добавить возможность выращивания культур',
  customPlantingRemoveCropOption: 'Удалить опцию посева',
  customPlantingCropSelectionRequiredError: 'Вы должны выбрать эту опцию. Если нет, выберите "Другое".',
  customPlantingOtherCropSelectionRequiredError: 'Должно быть введено, если выбрано "Другое"',
  customPlantingDeleteConfirmationMessage:
    'Вы уверены, что хотите удалить {plantingName}? (все связанные данные также будут удалены)',
  customPlantingFieldSelectionHint: 'Если имя поля не задано, оно не появится в списке.',

  customTaskDeleteMessage: 'Вы уверены, что хотите удалить выбранную работу?',
  customTaskDeleteFailure: 'Не удалось удалить выбранную работу',
  customTaskDeleteSucceed: 'Вы успешно удалили выбранную работу',

  customErrorStartDateRequired: 'Требуется дата начала',
  customErrorFieldRequired: 'Участки необходимы',

  customAlreadyExistingUser:
    'Вы уже зарегистрировали свой адрес электронной почты. Пожалуйста, используйте незарегистрированный адрес электронной почты.',

  customNowProgressRateTitle: 'Ход работы',
  customNowProgressRateNotField: 'Нет соответствующих участков',

  customStandardSubscribeErrorMessage:
    'Ваша покупка подписки не удалась. Пожалуйста, проверьте введенную вами информацию еще раз.',
  customStripeCouponText1: 'Нажмите здесь, чтобы погасить свой ваучер',
  customStripeCouponText2: 'Нажмите здесь для получения кода ваучера',

  customUpdatePolygonFailure: 'Я не обновил свои участки.',

  customMultiPolygonImportError:
    'Данные, содержащие мультиполигоны, которые должны быть преобразованы в полигоны, поскольку мультиполигоны не поддерживаются.',

  customSimpleSignUpAndSignInError:
    'Возникла проблема с вашим адресом электронной почты или паролем. Пожалуйста, проверьте.',
  customNewPasswordValidationError: 'Необходимо указать хотя бы одну строчную букву и одну цифру.',

  // 2022.12.08
  customSelectPlanSelectPaymentMethodText: 'Выберите способ оплаты',
  customCardInfoHasNotBeenEnteredError: 'Пожалуйста, введите данные вашей карты',
  customNoPaymentMethodSeletedError: 'Не выбран способ оплаты.',
  customFreeDashBoardText1: 'Для входа в AgriBus-Web требуется подписка на платный план (AgriBus Professional).',
  customFreeDashBoardText2: 'Смотрите дополнительную информацию.',
  customFreeDashBoardText3: 'Уведомление.',
  customFreeDashBoardText4: '',
  customContractPlanTitle: 'План по контракту',
  customComparePlansText: 'Сравнить планы',
  customUpgradeToPlusText: 'Повышение до уровня Plus',
  customDowngradeToPlusText: 'Понижение до уровня Plus.',
  customUpgradeToProfessionalText: 'Перейти на AgriBus Professional',
  customBillingBillingText1:
    'Отменен - автоматически преобразуется в бесплатный тарифный план по истечении срока действия.',
  customUpgradeConfirematoinText: 'Я перейду на версию AgriBus Professional. Вы не против?',
  customDowngradeConfiremationText: 'Мы понизим рейтинг до Plus. Вы не против?',
  customBankTransfer: 'банковский перевод',
  customHome: 'Главная',
  customBillingMessageSubscribeGoogle:
    'В настоящее время вы подписаны на Google Play Store; пожалуйста, обновите/понизите подписку в Google Play Store',
  customInvoiceReceiptAddresseeTitle: 'Адрес счета/квитанции',
  customChangeAddresseeBtnText: 'Изменить адрес.',
  customBillingEmailAddressTitle: 'Адрес электронной почты для выставления счетов',
  customChangeBillingEmailAddressText: 'Изменить адрес электронной почты для выставления счетов',
  customCannotDowngradeText: 'Банковские переводы не могут быть переведены в категорию Plus.',
  customChangePaymentMethodsToCard: 'Переход на оплату картой',
  customChangePaymentMethodsToCustomerBalance: 'Изменение на банковский перевод',
  customChangePaymentMethodToSendInvoiceText: 'Могу ли я изменить способ оплаты на банковский перевод?',
  customMapGaugeDescriptionColorCodedFill:
    'Если приложение было раскрашено по цветам, отображается история работы с цветовой кодировкой.',
  customColorCodeFill: 'Заполнение по цвету',
  customSelectDefaultIconTitle: 'Пожалуйста, выберите значок',
  customImportLimitMessage: 'Максимальное количество импортов равно {limit}.',
  customPresetIcon: {
    title: 'Предустановка',
    description: 'Выберите одну из шести различных предустановок.',
    btnText: 'Выбор из предустановок',
  },
  customBulkDeleteCheckboxText: 'массовое удаление',
  customBulkDeleteDialogText: 'Могу ли я выполнить массовое удаление?',
  customPerimeter: 'Периметр',
  feed: {
    menu: 'Лента',
    title: 'Лента новостей',
    description: 'Ежедневная региональная статистика полевых работ (анонимная) и новости регионов возделывания.',
    yourArea: 'Активность в вашем районе (~33 км)',
    areaFromFields: 'Определено по вашим полям',
    widerArea: 'Расширенный район (~55 км)',
    national: 'Активность по стране',
    daily: 'Вчера',
    weekly: 'Последние 7 дней',
    monthly: 'Последние 28 дней',
    vsNormal: 'к норме',
    vsLastYear: 'к прошлому году',
    noData: 'Недостаточно данных в этом районе (слишком мало работ поблизости).',
    noAreaHint: 'Зарегистрируйте свои поля, чтобы видеть статистику вашего района.',
    nationalFallback: 'Ниже показана статистика по стране.',
    upsell: 'Платные тарифы добавляют дневное и 28-дневное окна, а также обзор ~55 км.',
    monitorTitle: 'Еженедельный отчёт монитора',
    monitorActive: 'Наблюдаемый паттерн активен',
    monitorNone: 'Наблюдаемого паттерна нет',
    toMarketInsights: 'Открыть Market Insights',
    loadError: 'Не удалось загрузить ленту. Повторите попытку позже.',
    disclaimer: 'Региональная активность — это анонимная статистика, а не оценка отдельных хозяйств.',
    kindNews: 'Новости',
    kindPr: 'PR',
    readMore: 'Подробнее',
    entryDaily: 'Полевые работы {date}',
    entryWeekly: 'Недельная сводка (по {date})',
    areaC3: 'Ваш район',
    areaC5: 'Широкий район',
    areaJp: 'По стране',
    historyTitle: 'Динамика',
    kindSignal: 'Сигнал',
    shareTitle: 'Поделиться в ленте',
    share: 'Поделиться',
    shareVisibility: 'Видимость',
    visFollowers: 'Только подписчики',
    visNeighborhood: 'Соседи',
    visPublic: 'Все',
    shareRoute: 'Показать маршрут работы',
    shareExact: 'Показывать точное местоположение (карта)',
    statTime: 'Время',
    statDistance: 'Дистанция',
    statArea: 'Площадь',
    statWidth: 'Ширина',
    statSpeed: 'Скорость',
    statGnss: 'GNSS',
    shareComment: 'Комментарий',
    shareSubmit: 'Поделиться',
    sharePosted: 'Опубликовано',
    shareFailed: 'Не удалось выполнить. Повторите попытку позже.',
    consentNote: 'Публикация видна пользователям в выбранном диапазоне. Местоположение отображается только как примерный район (около 11 км).',
    consentLabel: 'Принимаю условия публикации (ст. 15-2)',
    postDelete: 'Удалить',
    postDeleted: 'Публикация удалена',
    postDeleteConfirm: 'Удалить эту публикацию?',
    report: 'Пожаловаться',
    reportTitle: 'Пожаловаться на публикацию',
    reportConfirm: 'Сообщить оператору об этой публикации?',
    reportReason: 'Причина (необязательно)',
    reportDone: 'Жалоба отправлена. Спасибо',
    visPrivate: 'Только я',
    followRequested: 'Запрошено',
    followAccept: 'Принять',
    followDecline: 'Отклонить',
    followAccepted: 'Запрос на подписку принят',
    unfollow: 'Отписаться',
    unfollowConfirm: 'Отписаться от этого пользователя?',
    connectionsHint: 'Отправляйте запросы на подписку из публикаций ленты. После принятия вы увидите записи только для подписчиков',
    sharePhotos: 'Добавить фото (до 4)',
    sharePhotosHint: 'Геоданные (EXIF) удаляются автоматически',
    snsShare: 'Поделиться',
    copyLink: 'Копировать ссылку',
    linkCopied: 'Ссылка скопирована',
    shareOther: 'Другие приложения',
    instagramSaved: 'Изображение сохранено. Опубликуйте его из приложения Instagram',
    manualRecords: 'Ручные записи',
    addManualRecord: 'Добавить ручную запись',
    manualChip: 'Ручная',
    recordStart: 'Начало',
    recordEnd: 'Окончание',
    recordMemo: 'Заметка',
    recordDuration: 'Длительность (мин)',
    recordCreated: 'Запись добавлена',
    recordDeleteConfirm: 'Удалить эту запись?',
    noManualRecords: 'Ручных записей пока нет',
    poiRecords: 'Точки интереса',
    addPoi: 'Добавить точку',
    poiTitle: 'Название',
    poiMapHint: 'Нажмите на карту, чтобы указать точку. Иначе используются данные фото',
    noPoiRecords: 'Точек пока нет',
    map: 'Карта',
    mapLayers: 'Слои',
    editMode: 'Режим редактирования',
    selected: 'Выбрано',
    mergeSave: 'Сохранить объединение',
    clipDraw: 'Нарисовать область обрезки',
    saveAsField: 'Сохранить посевную площадь как поле',
    workWidthM: 'Рабочая ширина (м)',
    workName: 'Название',
    workSaved: 'Производная запись сохранена',
    derivedRecords: 'Производные записи',
    derivedChip: 'Производная',
    derivedDeleteConfirm: 'Удалить эту производную запись?',
    saveRangeAsWork: 'Сохранить выбранный диапазон как производную запись',
    clipByField: 'Обрезать по полю',
    showOnMap: 'Показать на карте',
    editRange: 'Изменить диапазон',
    trajectoryChip: 'GPS',
    derivedRecordsDescription: 'Рабочие записи, связанные 1:1 с каждой траекторией. Изменённые и ручные записи также отображаются здесь',
    spatialEdit: 'Обрезка / Сохранить поле',
    vraTitle: 'Карта VRA',
    vraDescription: 'Создание зональных карт для дифференцированного внесения на основе спутниковых вегетационных индексов',
    vraGenerate: 'Создать новую карту',
    vraIndex: 'Вегетационный индекс',
    vraGridSize: 'Сетка (м)',
    vraDirection: 'Направление (град)',
    vraCloudPct: 'Макс. облачность (%)',
    vraImages: 'Использовано снимков',
    vraFailed: 'Не удалось создать. Возможно, нет безоблачных снимков за период',
    saveFailed: 'Не удалось сохранить',
    mapSetGenerated: 'Генерация завершена',
    fieldValidFromDate: 'Действительно с: {date}',
    fieldDeleteLinked: '{fieldName} нельзя удалить, так как оно связано со следующими данными.',
    fieldDeleteLinkedTasks: 'Записи работ: {count}',
    fieldDeleteLinkedSets: 'Наборы полей: {names}',
    fieldDeleteLinkedHint: 'Сначала удалите связанные записи работ и наборы полей.',
    elevSource: 'Источник',
    elevSourceDem: 'Спутник (DEM)',
    elevSourceGnss: 'История работ (GNSS)',
    elevCenter: 'Центр шкалы',
    elevCenterMean: 'Среднее',
    elevCenterMedian: 'Медиана',
    elevCenterValue: 'Высота центра',
    elevCustom: 'Свое значение',
    elevRange: 'Диапазон шкалы',
    elevRangeWidth: 'Ширина диапазона',
    elevContour: 'Изолинии',
    zoneBands: 'Зоны',
    zonePalette: 'Color scheme',
    paletteHue: 'HSI (green→yellow→red)',
    paletteYlgn: 'Yellow→Green',
    paletteGnrd: 'Green→Red',
    reclassifyTitle: 'Изменить зоны/цвета (без перегенерации)',
    reclassifyApply: 'Применить',
    followByEmail: 'Запрос подписки по e-mail',
    emailUserNotFound: 'Пользователь с этим e-mail не найден',
    followRequestSent: 'Запрос подписки отправлен',
    eventSettingsTitle: 'Feed settings (auto events)',
    eventSettingsVisibility: 'Event visibility',
    eventSettingsLocation: 'Location visibility',
    eventSettingsSnsStrip: 'Strip exact location when sharing to SNS (default)',
    eventSettingsPrefs: 'Events posted to your feed',
    locHidden: 'Hidden',
    locApprox: 'Approximate (~10 km grid)',
    locExact: 'Include exact location',
    event_work_start: 'Work started',
    event_work_end: 'Work finished',
    event_field_enter: 'Entered field',
    event_field_exit: 'Left field',
    event_poi_added: 'POI added',
    event_vra_map_added: 'VRA map added',
    event_elevation_map_added: 'Height map added',
    event_refline_added: 'Guidance line added',
    event_field_added: 'Field added',
    event_field_set_added: 'Field set added',
    event_work_start_text: 'started working ({name})',
    event_work_end_text: 'finished working ({name})',
    event_field_enter_text: 'entered field \u201c{name}\u201d',
    event_field_exit_text: 'left field \u201c{name}\u201d',
    event_poi_added_text: 'added POI \u201c{name}\u201d',
    event_vra_map_added_text: 'created VRA map \u201c{name}\u201d',
    event_elevation_map_added_text: 'created height map \u201c{name}\u201d',
    event_refline_added_text: 'added guidance lines ({name})',
    event_field_added_text: 'added field \u201c{name}\u201d',
    event_field_set_added_text: 'created field set \u201c{name}\u201d',
    vraNameAuto: 'Название (пусто = автоматически)',
    eventPrefOff: 'Do not post',
    visEditTitle: 'Change visibility',
    visEditLocationExact: 'Show exact location (map background)',
    visEditRemoveLocation: 'Remove exact location',
    visEditPublicNote: 'Exact location is automatically excluded for public posts',
    consentRequiredToShare: 'Sharing requires consent to the sharing terms. Enable sharing from a regular post first',
    elevGnssFailed: 'Не удалось рассчитать высоты. Нет истории работ (GNSS-высот), соответствующей фильтрам, или расчет еще выполняется. Ослабьте фильтр GNSS или диапазон дат',
    elevDescription: 'Создание карт высот поля по GNSS-высотам из истории работ (рекомендуется RTK). Без истории доступны спутниковые данные рельефа (DEM). Синхронизация с NAVI как у карт VRA',
    fieldValidUntil: 'Действительно до: {date}',
    mapSetGeneratedWithCount: 'Создано {created} / ошибок {failed} (существующие карты тех же полей заменяются)',
    vraGenerating: 'Анализ спутниковых снимков...',
    vraObsDate: 'Дата съёмки',
    vraPeriodMean: 'Среднее за период',
    vraLimitReached: 'Достигнут лимит создания (Free: 3 всего, платные тарифы: 10 в день)',
    vraExport: 'Экспорт ISOXML',
    vraModeGrid: 'Сетка (грид)',
    vraModePolygon: 'Полигон',
    vraRate: 'Норма внесения (кг/га)',
    vraCellSize: 'Размер ячейки (м)',
    vraEditMap: 'Изменить',
    mapSets: 'Наборы полей',
    mapSetDescription: 'Группируйте поля фильтром (период действия, культура, название). Используется для массовой генерации карт VRA',
    mapSetCreate: 'Создать набор полей',
    fieldSetEmpty: 'Наборов полей пока нет',
    mapSetTargetDate: 'Целевая дата',
    mapSetCrop: 'Культура',
    mapSetNameContains: 'Имя поля (содержит)',
    mapSetMemoContains: 'Заметка (содержит)',
    mapSetPreviewCount: 'Совпадающие поля',
    mapSetGenerate: 'Создать/Обновить',
    mapSetFields: 'Полей',
    mapSetLastGenerated: 'Последняя генерация',
    fieldAttrsTitle: 'Атрибуты поля (срок и культура)',
    fieldValidFrom: 'Действует с (пусто = бессрочно)',
    fieldValidTo: 'Действует до (пусто = бессрочно)',
    mapSetNoMatch: 'Нет полей, соответствующих фильтру',
    mapSetDeleteConfirm: 'Удалить этот набор полей и созданные из него карты VRA?',
    trajectories: 'Траектории',
  },
  marketInsights: {
    menu: 'Рыночная информация',
    title: 'Рыночная информация (AgriBus-DWH)',
    description: 'Ежедневно следите за ходом полевых работ и рыночными наблюдениями в основных регионах выращивания сои и пшеницы мира. Это преимущество для участников: ваши данные о работах (анонимная статистика) возвращаются к вам в виде полезной информации, например, при выборе времени продажи.',
    soybeanDescription: 'Состояние посевов и рыночные сигналы в соевых регионах Бразилии и США',
    wheatDescription: 'Состояние посевов и рыночные сигналы в пшеничных регионах',
    open: 'Открыть',
    upsell: 'Рыночная информация — это преимущество для участников с платным планом. С платным планом её можно просматривать без дополнительной платы.',
    memberNote: 'При просмотре в качестве участника в левом верхнем углу монитора отображается значок. Эта информация не является инвестиционной рекомендацией.',
  },
}
